import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';
import LinkedEntitiesCellBlock from '../../LinkedEntitiesCellBlock';
import getPropsFromEntity from './getPropsFromEntity';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import { padStart } from './helpers/utils';

const MeetingItemLinkedEntitiesCellBlock = ({ entity, env, region, projectId, ...props }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  const { meeting } = entity;
  const numInSeries = padStart(meeting.numInSeries);
  const title = `${T.translate('IN')} ${numInSeries} ${meeting.title}`;

  const entityProps = { ...getPropsFromEntity({ entity, env, region, projectId, T }), title };

  return <LinkedEntitiesCellBlock {...props} {...entityProps} />;
};

MeetingItemLinkedEntitiesCellBlock.propTypes = {
  /**
   * The Meeting Item entity we need to render.
   */
  entity: PropTypes.object.isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default MeetingItemLinkedEntitiesCellBlock;
